import { useEffect } from 'react';
import { useServices } from '@/model';
import { installCommunityCleanup } from './runtime';

export function DiscoverCleanupRuntime() {
  const services = useServices();
  useEffect(() => installCommunityCleanup(services), [services]);
  return null;
}
